import { render, staticRenderFns } from "./botLogInfo.vue?vue&type=template&id=2a4c2498&scoped=true&lang=pug&"
import script from "./botLogInfo.vue?vue&type=script&lang=js&"
export * from "./botLogInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c2498",
  null
  
)

export default component.exports